import { Link } from 'react-router-dom';
import { Star, Eye } from 'lucide-react';
import { useState } from 'react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

export default function ProductCard({ product, onQuickView }) {
  const [hover, setHover] = useState(false);
  const { addItem } = useCart();
  const img = product.images[hover && product.images[1] ? 1 : 0];

  return (
    <article
      data-testid={`product-card-${product.id}`}
      data-analytics-id="product_card"
      data-analytics-name={product.name}
      data-analytics-product={product.id}
      data-analytics-impression=""
      className="card-essenya group relative flex flex-col"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Link to={`/prodotto/${product.slug}`} className="block relative overflow-hidden aspect-[4/5] bg-white">
        <img src={img} alt={product.name} className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        {product.badge && (
          <span data-testid={`product-badge-${product.id}`} className="absolute top-3 left-3 bg-white text-essenya-ink text-[10px] font-semibold px-3 py-1 rounded-full uppercase tracking-wider">{product.badge}</span>
        )}
        <button
          data-testid={`quick-view-${product.id}`}
          onClick={(e) => { e.preventDefault(); onQuickView && onQuickView(product); }}
          className="absolute bottom-3 right-3 bg-white/95 backdrop-blur rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity"
          aria-label="Anteprima rapida"
        >
          <Eye size={16} strokeWidth={1.5} />
        </button>
      </Link>
      <div className="p-5 flex flex-col gap-2 flex-1">
        <div className="text-eyebrow">{product.categoryLabel} · {product.fragranceLabel}</div>
        <Link to={`/prodotto/${product.slug}`} className="font-display text-lg leading-tight hover:underline underline-offset-4">{product.name}</Link>
        <p className="text-sm text-essenya-text">{product.subtitle}</p>
        <div className="flex items-center gap-1 text-sm">
          {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={13} strokeWidth={1.5} className={i < Math.round(product.rating) ? 'fill-essenya-ink text-essenya-ink' : 'text-essenya-border'} />)}
          <span className="text-essenya-text ml-1 text-xs">({product.reviews})</span>
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="font-display text-xl">{product.price.toFixed(2).replace('.', ',')}€</span>
          {product.originalPrice && <span className="text-essenya-text line-through text-sm">{product.originalPrice.toFixed(2).replace('.', ',')}€</span>}
        </div>
        <div className="mt-3 flex gap-2">
          {product.category === 'bundle' ? (
            <Link to="/bundle" data-testid={`create-bundle-${product.id}`} className="flex-1 btn-primary py-3 px-4 text-sm text-center">Crea il tuo bundle</Link>
          ) : (
            <>
              <button
                data-testid={`add-to-cart-${product.id}`}
                onClick={() => { addItem(product.id, 1); toast.success(`${product.name} aggiunto al carrello`); }}
                className="flex-1 btn-primary py-3 px-4 text-sm"
              >Aggiungi al carrello</button>
              <Link to={`/prodotto/${product.slug}`} data-testid={`view-details-${product.id}`} className="btn-secondary py-3 px-4 text-sm">Dettagli</Link>
            </>
          )}
        </div>
        <p className="text-xs text-essenya-text mt-1">Spedizione tracciata · Pagamento sicuro</p>
      </div>
    </article>
  );
}
